import React from "react";
import styled from "styled-components";
import { Form, Row, Col } from "antd";
import { Metrics } from "../../theme";

const Item = styled(Form.Item)`
    margin-bottom: ${Metrics.form.item.marginBottom}px;
`;
const InlineItem = ({children, gutter = Metrics.button.spaceMargin})=>(
	<Item>
		<Row type='flex' align='middle' gutter={gutter}>
			{Array.isArray(children) && children.length > 0 ? 
				children.map((element,index)=>(<Col key={index}>{children[index]}</Col>)) :
				{children}
			}
		</Row>
	</Item>
);
export default {
	Item,
	InlineItem,
};


// WEBPACK FOOTER //
// ./src/components/form/OForm.js